import React, { useState, useEffect } from "react";
//import TituloCard from "../../atoms/titles/Titulo";
import "./cardNoResumen.scss";
import ConsultaNominas from "../modals/consultaNominas/ConsultaNominas";
import Logo from "../../../resources/img/icono-area-personal.png";

const NominaNoResumen = () => {
  const [show, setShow] = useState({ nomina: false, mensaje: false });
  const handleShow = (e) => {
    setShow(e);
  };

  const handleClose = (e) => {
    setShow(false);
  };
  useEffect(() => { }, []);

  return (
    <section className="temas">
      <div className="card-caja-mini temas card m-4 h-auto"
        onClick={() => handleShow({ nomina: true })}
        tabIndex={0}
        role="button"
        title="Nómina"
        aria-label="Nómina"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            handleShow({ nomina: true })
          }
        }}
        >

        <div className="tituloAccesibilidad d-flex align-items-center" >
          <img

            alt="Nómina"
            src={Logo}
          />
          <h3 className="tituloAccesibilidad ms-2">Nómina</h3>
        </div>
        <span className="mx-4">Últimas nóminas disponibles para consultar.</span>

      </div>
      {show.nomina ? (
        <ConsultaNominas
          show={show}
          handleClose={handleClose}
        ></ConsultaNominas>
      ) : null}
    </section>
  );
};
export default NominaNoResumen;
